import React from 'react';
import Text from 'components/Text/index.js';
import { Button } from 'components/Button/index.js';

export const ConnectButton = ({onClick, ...props}) => {
    return (
        <Button className='connect-button' mod='gold' onClick={onClick} {...props} >
            <Text>Подключиться</Text>
        </Button>
    )
}
